<script lang="ts">
export type { Card } from './WhereToConsultCard.vue';
</script>

<script lang="ts" setup>
const props = defineProps<{
  keyword: string;
  title: string;
  dateModified: string;
}>();

const {
  public: { appOrigin },
} = useRuntimeConfig();
const route = useRoute();
const currentCanonicalUrl = appOrigin + route.path.replace(/\/+$/, '');

useJsonld(
  {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: props.title,
    url: currentCanonicalUrl,
    dateModified: props.dateModified,
    mainEntityOfPage: currentCanonicalUrl,
    author: [],
    editor: [
      {
        '@type': 'Person',
        name: 'オカネコ編集部 ',
        hasCredential: [
          {
            '@type': 'EducationalOccupationalCredential',
            name: '金融サービス仲介業者 関東財務局長（金サ）第１号',
          },
          {
            '@type': 'EducationalOccupationalCredential',
            name: 'ISO/IEC 27001:2013',
          },
          {
            '@type': 'EducationalOccupationalCredential',
            name: 'JIS Q 27001:2014',
          },
          {
            '@type': 'EducationalOccupationalCredential',
            name: '有料職業紹介事業（厚生労働大臣許可番号：13-ユ-315915）',
          },
        ],
        affiliation: {
          '@type': 'Organization',
          name: useConstants().CORPORATION.name,
          sameAs: useConstants().CORPORATION.webPage,
        },
      },
    ],
    publisher: {
      '@type': 'Organization',
      '@id': `${useConstants().CORPORATION.webPage}#Organization`,
      name: useConstants().CORPORATION.name,
      url: useConstants().CORPORATION.webPage,
      logo: {
        '@type': 'ImageObject',
        '@id': `${useConstants().CORPORATION.webPage}/ogp.png#ImageObject`,
        url: `${useConstants().CORPORATION.webPage}/ogp.png`,
      },
      image: {
        '@type': 'ImageObject',
        '@id': `${useConstants().CORPORATION.webPage}/ogp.png#ImageObject`,
        url: `${useConstants().CORPORATION.webPage}/ogp.png`,
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: useConstants().CORPORATION.address.streetAddress,
        addressLocality: useConstants().CORPORATION.address.addressLocality,
        addressRegion: useConstants().CORPORATION.address.addressRegion,
        postalCode: useConstants().CORPORATION.address.postalCode,
        addressCountry: 'JP',
        telephone: useConstants().CORPORATION.telephone,
      },
      founder: {
        '@type': 'Person',
        name: useConstants().CORPORATION.founder,
      },
      foundingDate: useConstants().CORPORATION.foundingDate,
      sameAs: [],
    },
  },
  {
    tagPosition: 'bodyClose',
  }
);
</script>

<template>
  <div v-if="$slots.default" :class="$style.container">
    <h1 :class="[$style.container__title, $style.title]">
      {{ title }}
    </h1>
    <div :class="[$style.container__cardList, $style.cardList]">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;
.container {
  max-width: $content-width;
  padding: 0 16px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  line-height: 50.4px;
  text-align: center;

  @include mobile-only {
    font-size: 24px;
    line-height: 33.6px;
  }
}

.cardList {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 40px;

  @include mobile-only {
    margin-top: 32px;
    gap: 16px;
  }
}
</style>
